import { gql } from 'apollo-angular';

export const featureToggleFragment = gql`
  fragment FeatureToggle on FeatureToggle {
    id
    key
    active
    activateOn
  }
`;
